/* import __COLOCATED_TEMPLATE__ from './article-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();